// Draft survey types
export const DRAFT_SURVEY_TYPE = {
    ARRIVAL: 'arrival',
    DEPARTURE: 'departure',
}

// Draft survey validation constants
export const MINIMUM_DRAFT_VALUE = 0
export const MAXIMUM_DRAFT_VALUE = 20

// Water density validation constants
export const MINIMUM_WATER_DENSITY_VALUE = 1
export const MAXIMUM_WATER_DENSITY_VALUE = 1.05